import { useWindowStore } from '../store/windowStore';
import { WindowFrame } from './WindowFrame';

export function WindowHost() {
  const windows = useWindowStore((s) => s.windows);
  const visible = windows
    .filter((w) => !w.minimized)
    .sort((a, b) => a.zIndex - b.zIndex);

  // Host 层自身不能拦截点击事件，否则即使没有窗口，
  // 只要这层被渲染出来，下面的桌面图标就会无法点击。
  // 每个 WindowFrame 会在自己的矩形区域内通过 pointer-events-auto
  // 重新开启事件响应。
  return (
    <div className="os-window-host pointer-events-none absolute inset-0">
      {visible.map((w) => (
        <WindowFrame key={w.id} win={w} />
      ))}
    </div>
  );
}
